import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  FuelParameters,
  FuelSourceConfig,
  FuelSources,
  ScenarioSettingsPage,
  ScenarioSettingsPageConfig
} from 'src/redux/slices/analysis/consts'
import { updateFuelScenarioSettings } from 'src/redux/slices/analysis/reducers'
import { getProject } from 'src/redux/slices/project/endpoints'
import { selectActiveProjectId } from 'src/redux/slices/project/selectors'
import { Project } from 'src/types/database-model'

import { Button } from '@material-ui/core'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

import ScenarioFuelParameter from './ScenarioFuelParameter'
import { DividerWrapper, Header } from './SettingLayout'

type ScenarioSettingsFuelsProps = {
  scenarioName: string
}

const useStyles = makeStyles(() => ({
  centeredButton: {
    margin: '0px auto',
    // width: '50%',
    display: 'block',
  },
}))

const ScenarioSettingsFuels: React.FC<ScenarioSettingsFuelsProps> = ({ scenarioName }) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const hasActiveProject = useSelector(selectActiveProjectId)
  const { data: project } = getProject.useQuery('')
  const copySettingsFromProject = useCallback(() => {
    if (!project) return
    FuelParameters.forEach((parameterKey) => {
      FuelSources.forEach((fuelSource) => {
        const parameter: keyof Project =
          `${fuelSource.toLowerCase()}_${parameterKey.toLowerCase()}` as keyof Project
        const value = project[parameter] as number
        if (value) {
          dispatch(
            updateFuelScenarioSettings({
              scenarioName,
              fuelSource,
              parameterKey,
              value,
            }),
          )
        }
      })
    })
  }, [dispatch, project])
  return (
    <Card variant='outlined'>
      <CardContent>
        {/* Header for Scenario */}
        <Header name={ScenarioSettingsPageConfig[ScenarioSettingsPage.Fuels].label} />

        {/* Header for Scenario Fuel Source Config */}
        <Grid container spacing={3}>
          {Object.entries(FuelSourceConfig).map(([key, { label }]) => (
            <Grid key={`${key}-settings`} item container alignItems='center' xs={4}>
              <DividerWrapper>
                <Typography variant='overline' style={{ margin: '0 0.5rem' }}>
                  {label}
                </Typography>
              </DividerWrapper>
            </Grid>
          ))}
        </Grid>

        {/* Scenario Fuel Source Controls */}
        {/* Rows = Parameter, Columns = Fuel Source */}
        {FuelParameters.map((parameterKey, i) => (
          <Grid container key={`${parameterKey}-controls-${i}`} spacing={3}>
            {FuelSources.map((fuelSource, j) => (
              <Grid
                item
                xs={4}
                key={`${scenarioName}-${parameterKey}-${fuelSource}-control-${i}-${j}`}
                style={{ marginBottom: '0.5rem' }}
              >
                <ScenarioFuelParameter
                  scenarioName={scenarioName}
                  parameterKey={parameterKey}
                  fuelSource={fuelSource}
                />
              </Grid>
            ))}
          </Grid>
        ))}
        {hasActiveProject && (
          <Button
            variant='outlined'
            size='small'
            onClick={copySettingsFromProject}
            className={classes.centeredButton}
          >
            Copy settings from project
          </Button>
        )}
      </CardContent>
    </Card>
  )
}

export default ScenarioSettingsFuels
